// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import LrrSchema from './lrr-schema';

const schema = {
  $id: '/lrrs-schema',
  type: 'object',
  required: [],
  properties: {
    lrr: {
      type: 'array',
      nullable: true,
      items: { ...LrrSchema },
    },
  },
} as IJSONSchema;

export default schema;
